import { Tag } from '@cian/components';
import * as React from 'react';

import { EParkingType } from '../../../../json_query';
import { IParkingTypesTag } from '../../../state/tags/definitions/parking';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IParkingTypesTagItemProps {
  tag: IParkingTypesTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const parkingTypeMap = {
  [EParkingType.Ground]: 'Наземная',
  [EParkingType.Multilevel]: 'Многоуровневая',
  [EParkingType.Underground]: 'Подземная',
  [EParkingType.Rooftop]: 'на крыше',
};

export const ParkingTypesTagItem = ({ onDeleteClick, tag, withNewTag }: IParkingTypesTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {tag.value === EParkingType.Rooftop
        ? `Парковка ${parkingTypeMap[tag.value]}`
        : `${parkingTypeMap[tag.value]} парковка`}
    </TagComponent>
  );
};
